import axios from 'axios';

const useAcceptTerms = () => {
  const acceptTerms = async () => {
    await axios.post(`${process.env.NEXT_PUBLIC_API_APP_ENDPOINT}/customer/accept-terms`);
  };

  return { acceptTerms };
};

export { useAcceptTerms };
